import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import themeable from 'zignal-landscape/lib/themeable';
import Loading from 'zignal-landscape/lib/Loading';
import { drawNodeToCanvas, getLinkColor } from '../../components/ClusterGraph/drawingUtils';

import * as actions from '../../BotIntelligence.ducks';
import ClusterGraph from '../../components/ClusterGraph';
import Tooltip from '../../components/Tooltip';
import CategoryGraph from '../../components/CategoryGraph';
import GraphLegend from '../../components/GraphLegend';

const mapStateToProps = (
  (state) => ({
    isLoading: state.BotIntelligence.Page.isLoading,
    selectedSizeNodeByOption: state.BotIntelligence.Page.selectedSizeNodeByOption,
    selectedTopClustersByVolume: state.BotIntelligence.Page.selectedTopClustersByVolume,
    selectedViewByOption: state.BotIntelligence.Page.selectedViewByOption,
    showSelectionOnly: state.BotIntelligence.Page.showSelectionOnly,
    filteredAutomationScore: state.BotIntelligence.Page.filteredAutomationScore,
    authorNodes: state.BotIntelligence.Page.authorNodes,
    viewBy: state.BotIntelligence.Page.viewBy,
    hoverMap: state.BotIntelligence.Page.hoverMap,
    timezone: state.AppUser.user.timezone
  })
);

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class GraphContainer extends React.Component {

  shouldComponentUpdate(nextProps) {
    return (
      this.props.hoverMap.hoverId !== nextProps.hoverMap.hoverId
      || this.props.selectedSizeNodeByOption.value !== nextProps.selectedSizeNodeByOption.value
      || this.props.isLoading !== nextProps.isLoading
      || this.props.showSelectionOnly !== nextProps.showSelectionOnly
      || this.props.selectedViewByOption !== nextProps.selectedViewByOption
      || this.props.clusterNodes !== nextProps.clusterNodes
      || this.props.filteredAutomationScore !== nextProps.filteredAutomationScore
      || (
        this.props.showSelectionOnly
        && this.props.selectedTopClustersByVolume.length !== nextProps.selectedTopClustersByVolume.length
      )
    );
  }

  render() {
    const {
      styles,
      isLoading,
      selectedSizeNodeByOption,
      selectedTopClustersByVolume,
      selectedViewByOption,
      setAddToGroupModalVisibility,
      showSelectionOnly,
      filteredAutomationScore,
      authorNodes,
      clusterNodes,
      clusterLinks,
      viewBy,
      isUserDiscoverFeatureEnabled,
      setGraphHover,
      hoverMap,
      timezone,
      searchDiscover,
    } = this.props;

    const tooltip = (<Tooltip
      hoverMap={hoverMap}
      timezone={timezone}
      addToGroup={(author) => setAddToGroupModalVisibility(true, author)}
      isUserDiscoverFeatureEnabled={!!selectedViewByOption.searchPattern && isUserDiscoverFeatureEnabled}
      searchDiscover={searchDiscover}
    />);

    const selectedGraph = (viewBy === 'cluster') ? (
      <ClusterGraph
        filteredAutomationScore={filteredAutomationScore}
        authorNodes={authorNodes}
        clusterNodes={clusterNodes}
        clusterLinks={clusterLinks}
        sizeBy={selectedSizeNodeByOption.value}
        hoverMap={hoverMap}
        setGraphHover={setGraphHover}
        selectedTopClustersByVolume={selectedTopClustersByVolume}
        showSelectionOnly={showSelectionOnly}
        drawNodeToCanvas={drawNodeToCanvas}
        getLinkColor={getLinkColor}
        tooltip={tooltip}
        selectedViewByOption={selectedViewByOption.value}
      />
    ) : (
      <CategoryGraph
        filteredAutomationScore={filteredAutomationScore}
        authorNodes={authorNodes}
        clusterNodes={clusterNodes}
        sizeBy={selectedSizeNodeByOption.value}
        setGraphHover={setGraphHover}
        selectedTopClustersByVolume={selectedTopClustersByVolume}
        showSelectionOnly={showSelectionOnly}
        selectedViewByOption={selectedViewByOption.value}
        hoverMap={hoverMap}
        tooltip={tooltip}
      />
    );
    const emptyGraph = <div className={styles.emptyGraph} />;

    return isLoading ? <section className={styles.loadingSpinner}><Loading /></section> : (
      <section className={styles.GraphSection}>
        {authorNodes.length > 0 ? selectedGraph : emptyGraph}
        <GraphLegend />
      </section>
    );
  }
}

GraphContainer.propTypes = {
  styles: PropTypes.object,
  isLoading: PropTypes.bool,
  selectedSizeNodeByOption: PropTypes.object,
  selectedTopClustersByVolume: PropTypes.array,
  selectedViewByOption: PropTypes.object,
  showSelectionOnly: PropTypes.bool,
  filteredAutomationScore: PropTypes.object,
  authorNodes: PropTypes.arrayOf(PropTypes.object),
  timezone: PropTypes.string,
  hoverMap: PropTypes.object,
  viewBy: PropTypes.string,
  // passed from parent
  clusterNodes: PropTypes.array,
  clusterLinks: PropTypes.array,
  isUserDiscoverFeatureEnabled: PropTypes.bool,
  // actions
  setAddToGroupModalVisibility: PropTypes.func,
  setGraphHover: PropTypes.func,
  searchDiscover: PropTypes.func
};

GraphContainer.defaultProps = {
  selectedSizeNodeByOption: {},
  selectedViewByOption: {},
  hoverMap: {},
  isUserDiscoverFeatureEnabled: false
};

export default connect(mapStateToProps, actions, mergeProps)(themeable(GraphContainer));
